/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit,
} from '@angular/core';
import { DashboardService } from '../shared/dashboard.service';

// The My Devices card: the tester's devices, and a link to add more in the tester app.
@Component({
  selector: 'ut-dashboard-my-devices',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './dashboard-my-devices.component.html',
  styleUrls: ['./dashboard-my-devices.component.scss'],
})
export class DashboardMyDevicesComponent implements OnInit {
  @Input() testerAppUrl = '';

  devices: any[] = [];

  constructor(private dashboardService: DashboardService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.dashboardService.devices().then((devices) => {
      this.devices = devices || [];
      this.cdr.markForCheck();
    }, () => {
      // The card still offers "+ Add devices".
    });
  }
}
